import { useEffect, useState } from 'react';

export default function BrandIntro() {
  const [phase, setPhase] = useState<'hidden' | 'show' | 'exit'>(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || sessionStorage.getItem('nwg_intro_seen')) return 'hidden';
    return 'show';
  });

  useEffect(() => {
    if (phase !== 'show') return;
    sessionStorage.setItem('nwg_intro_seen', '1');
    const t1 = setTimeout(() => setPhase('exit'), 2300);
    const t2 = setTimeout(() => setPhase('hidden'), 3000);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [phase]);

  if (phase === 'hidden') return null;
  return (
    <div
      className={`brand-intro ${phase === 'exit' ? 'brand-intro-exit' : ''}`}
      data-testid="brand-intro"
      aria-hidden="true"
    >
      <div className="brand-intro-halo" />
      <img
        className="brand-intro-logo"
        src="/brand/nwg-logo-web.png"
        alt="NextWealth Global — Show Us the Problems. We Build the Solutions."
      />
    </div>
  );
}
